// Utility for smooth scrolling to hash element

export function scrollToHash(hash) {
  if (hash) {
    const el = document.getElementById(hash.replace("#", ""));
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
}
